document.addEventListener('DOMContentLoaded', function () {
 const CART_MORE = document.querySelector('#load-more'),
       NOTES = document.querySelector('.cart__footer__notes');
            
 if (CART_MORE && window.innerHeight >= 600) {
   CART_MORE.addEventListener('click', function() {
     let TOTAL = document.querySelector('.docapp-coupon-input.docapp-in-summary'); 
     this.classList.toggle('open');
     if (NOTES) {
       NOTES.classList.toggle('hide');
     }
     if (TOTAL) {
       TOTAL.classList.toggle('hide');
     }
   })
 } 
 if (window.innerHeight < 600 && CART_MORE) {
   CART_MORE.addEventListener('click', function() {
     let TOTAL = document.querySelector('.docapp-coupon-input.docapp-in-summary'); 
     this.classList.toggle('open');
      if (NOTES) {
          if (window.getComputedStyle(NOTES).display === 'none') {
              NOTES.style.setProperty('display', 'block', 'important');
          } else {
              NOTES.style.setProperty('display', 'none', 'important');
          }
      }

      if (TOTAL) {
          if (window.getComputedStyle(TOTAL).display === 'none') {
              TOTAL.style.setProperty('display', 'block', 'important');
          } else {
              TOTAL.style.setProperty('display', 'none', 'important');
          }
      }
   })
 }
})

function showDetails(elem) {
  elem.classList.toggle('open');
  elem.nextElementSibling.classList.toggle('open');
}